export interface U2000GetHandlersParams<T extends { id: string } = any> {
  doGetFn: (id: string) => Promise<any>;
  onSuccess?: (row: T) => void;
  onError?: (errors: { error: any }) => void;
}

export interface U2000GetHandlersReturn {
  getData: (id: string) => void;
}

export function useU2000GetHandlers<T extends { id: string } = any>({ doGetFn, onSuccess, onError }: U2000GetHandlersParams<T>): U2000GetHandlersReturn {
  const getData = async (id: string) => {
    try {
      const response = await doGetFn(id);
      const row: T = response.data.result as unknown as T;

      if (onSuccess) {
        onSuccess(row as unknown as T);
      }
    } catch (error) {
      if (onError) {
        onError({ error });
      }
    }
  };

  return { getData };
}
